interface Props {
  className?: string;
  size?: number;
}

export default function Logo({ className = "", size = 64 }: Props) {
  return (
    <img
      src="/logo.webp"
      alt="Tennis Ledger logo"
      width={size}
      height={size}
      className={className}
      fetchPriority="high"
      decoding="async"
      style={{
        objectFit: "contain",
        filter:
          "drop-shadow(0 0 14px hsl(75 100% 65% / 0.85)) drop-shadow(0 0 28px hsl(75 100% 60% / 0.55)) drop-shadow(0 2px 6px hsl(0 0% 0% / 0.6))",
      }}
    />
  );
}
